export const CARD = {
  ITEM_CREATED: 'Card item created.',
  NOT_FOUND: 'Card item not found.',
  ITEM_DELETED: 'Card item deleted.',
  ITEM_UPDATED: 'Card item updated.',
  REORDER: 'Card items reordered.',
} as const;

export const CARD_SETTINGS = {
  UPDATED: 'Card settings updated.',
} as const;

export const CREDIT_CARD = {
  ADDED: 'Credit card added.',
  EXISTS: 'Credit card already exists.',
  DELETED: 'Credit card deleted.',
} as const;
